import { render } from "./UkkoturvaIndex.vue?vue&type=template&id=dd7931ae"
import script from "./UkkoturvaIndex.vue?vue&type=script&lang=js"
export * from "./UkkoturvaIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__